/*
function startTimer() {
    $(".hero .timer").remove();
    $('<div class="timer"/>').appendTo($(".hero"));
    window.setTimeout(function () {
        $(".hero .timer").addClass("counting");
    }, 10); // need a slight delay so the class is added after the DOM update
}
$(".hero-slider").on("beforeChange", function (event, slick, direction) {
    startTimer();
});
$(".hero-slider").on("init", function (event, slick, direction) {
    startTimer();
});
$(".hero-slider").slick({
    prevArrow: window.slideBtns.prev, // in footer.php so we can inline svg
    nextArrow: window.slideBtns.next,
    // autoplay: true,
    // autoplaySpeed: 7850, // keep this value in sync with .timer in blocks/_hero.scss
    speed: 1000,
    accessibility: false,
    adaptiveHeight: true,
});
*/

$(".testimonials .slider").slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    accessibility: false,
});

$(".photo-slider .items").on("init", function (event, slick, direction) {
    let totalHeight = $(".photo-slider .slick-track").outerHeight();
    $(".photo-slider .item").each(function () {
        let imgHeight = $(this).find("img").outerHeight();
        $(this).css("padding-top", (totalHeight - imgHeight) / 2);
    });
});
$(".photo-slider .items").slick({
    variableWidth: true,
    arrows: true,
    dots: false,
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    accessibility: false,
    responsive: [
        {
            breakpoint: app.breakpoints.md,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
            },
        },
    ],
});

$(".entry-slider").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: app.breakpoints.md,
            settings: {
                slidesToShow: 4,
            },
        },
    ],
});

$(".card-slider").on("init", function (slick) {
    let $slider = $(".card-slider");
    var trackHeight = $slider.find(".slick-track").outerHeight();
    $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
});
$(".card-slider").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: app.breakpoints.lg,
            settings: "unslick",
        },
    ],
});

$(".product-slider .items").on("init", function (slick) {
    let $slider = $(".product-slider .items");
    var trackHeight = $slider.find(".slick-track").outerHeight();
    $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
});
$(".product-slider .items").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: app.breakpoints.lg,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
    ],
});

/*
PDP
*/
$(".product-media .main").slick({
    arrows: false,
    adaptiveHeight: true,
    accessibility: false,
    dots: false,
    responsive: [
        {
            breakpoint: app.breakpoints.lg,
            settings: {
                dots: true
            },
        }
    ]
});
$('.product-media .thumbs button').on('click', function (e) {
    e.preventDefault();
    $(".product-media .main").slick('slickGoTo', $(this).data('index'));
    $('.product-media .thumbs button').removeClass('active');
    $(this).addClass('active');
});

$("#related-products-slider").on("init", function (slick) {
    let $slider = $("#related-products-slider");
    var trackHeight = $slider.find(".slick-track").outerHeight();
    $slider.find(".slick-slide").css("height", trackHeight + "px"); // equalize content heights
});
$("#related-products-slider").slick({
    prevArrow: window.slideBtns.prev,
    nextArrow: window.slideBtns.next,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    infinite: false,
    accessibility: false,
    responsive: [
        {
            breakpoint: app.breakpoints.md,
            settings: {
                slidesToShow: 4,
                variableWidth: false,
            },
        },
        {
            breakpoint: app.breakpoints.lg,
            settings: {
                slidesToShow: 3,
                variableWidth: false,
            },
        },
        {
            breakpoint: 1365,
            settings: {
                slidesToShow: 4,
                variableWidth: false,
            },
        },
    ],
});
